export default {
  title: 'footer',
  intro: 'Der einfachste Weg dein Junior Sales Team aufzubauen!',
  business: 'HYRE Talent Sourcing and Matching GmbH',
  customer: [
    {
      title: 'Firmen',
      intro: 'Wir nehmen dein Talentbedarf an und gehen ihn mit Kreativität und Präzision an.',
      cta: 'Termin buchen!',
      cta_link: 'https://calendly.com/hyre-sales-team/intro',
    },
  ],
  talents: [
    {
      title: 'Talente',
      intro: 'Neugierig welche Positionen wir für dich haben?',
      cta: 'Top Sales Jobs finden!',
      cta_link: '/jobs',
    },
  ],
  social_links: [
    {
      name: 'TikTok',
      link: 'https://www.tiktok.com/@hyretalents',
    },
    {
      name: 'instagram',
      link: 'https://www.instagram.com/hyre_talents/',
    },
    {
      name: 'linkedin',
      link: 'https://www.linkedin.com/company/hyretalents/',
    },
  ],
  privacy_links: [
    {
      name: 'Login',
      link: '/login',
    },
    {
      name: 'Impressum',
      link: '/impressum',
    },
    {
      name: 'Datenschutzerklärung',
      link: '/privacy-policy',
    },
    {
      name: 'Geschäftsbedingungen',
      link: '/terms-and-conditions',
    },
    {
      name: 'Cookie-Erklärung',
      link: '/cookie-declaration',
    },
  ],
}
